/* ============================================================
   GlassIcons — vanilla port of the React Bits component
   https://reactbits.dev

   Same API shape as the JSX original:

     GlassIcons.render(container, items, { className })

     items: [{ icon, color, label, customClass }]
            `icon` is an SVG sprite id ('#i-clip'), raw SVG/HTML,
            or a DOM node — the JSX version only took a React element.

   Plus two helpers the React version has no need for, because this
   page has existing markup to upgrade rather than a blank grid:

     GlassIcons.tile(icon, color)      -> a caption-less tile node
     GlassIcons.enhanceButtons(sel)    -> adds the two plates to
                                          existing text buttons
   ============================================================ */
(function (global) {
  'use strict';

  // The source's six hues, kept so the component stays reusable, plus
  // the blue family this site actually draws from.
  var gradientMapping = {
    blue:   'linear-gradient(hsl(223, 90%, 50%), hsl(208, 90%, 50%))',
    purple: 'linear-gradient(hsl(283, 90%, 50%), hsl(268, 90%, 50%))',
    red:    'linear-gradient(hsl(3, 90%, 50%), hsl(348, 90%, 50%))',
    indigo: 'linear-gradient(hsl(253, 90%, 50%), hsl(238, 90%, 50%))',
    orange: 'linear-gradient(hsl(43, 90%, 50%), hsl(28, 90%, 50%))',
    green:  'linear-gradient(hsl(123, 90%, 40%), hsl(108, 90%, 40%))',

    sky:    'linear-gradient(hsl(204, 88%, 50%), hsl(196, 88%, 41%))',
    azure:  'linear-gradient(hsl(216, 88%, 52%), hsl(224, 84%, 44%))',
    deep:   'linear-gradient(hsl(222, 70%, 38%), hsl(216, 74%, 28%))',
    navy:   'linear-gradient(hsl(220, 55%, 26%), hsl(212, 60%, 19%))'
  };

  function backgroundFor(color) {
    return gradientMapping[color] || color;
  }

  function iconNode(icon) {
    if (icon && icon.nodeType) return icon;
    var span = document.createElement('span');
    span.style.cssText = 'display:flex;width:100%;height:100%';
    if (typeof icon === 'string' && icon.charAt(0) === '#') {
      span.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
        '<use href="' + icon + '"></use></svg>';
    } else {
      span.innerHTML = icon || '';
    }
    return span;
  }

  function build(item, tag) {
    var el = document.createElement(tag || 'button');
    if (el.tagName === 'BUTTON') el.type = 'button';
    el.className = 'icon-btn ' + (item.customClass || '');
    if (item.label) el.setAttribute('aria-label', item.label);

    var back = document.createElement('span');
    back.className = 'icon-btn__back';
    back.style.background = backgroundFor(item.color);

    var front = document.createElement('span');
    front.className = 'icon-btn__front';

    var ico = document.createElement('span');
    ico.className = 'icon-btn__icon';
    ico.setAttribute('aria-hidden', 'true');
    ico.appendChild(iconNode(item.icon));
    front.appendChild(ico);

    el.appendChild(back);
    el.appendChild(front);

    if (item.label) {
      var label = document.createElement('span');
      label.className = 'icon-btn__label';
      label.textContent = item.label;
      el.appendChild(label);
    }
    return el;
  }

  var GlassIcons = {
    gradients: gradientMapping,

    render: function (container, items, opts) {
      opts = opts || {};
      if (typeof container === 'string') container = document.querySelector(container);
      if (!container) return null;
      container.classList.add('icon-btns');
      if (opts.className) container.className += ' ' + opts.className;
      container.innerHTML = '';
      (items || []).forEach(function (item) {
        container.appendChild(build(item, opts.tag));
        if (typeof item.onClick === 'function') {
          container.lastChild.addEventListener('click', item.onClick);
        }
      });
      return container;
    },

    // A single decorative tile — no label, no button semantics, for
    // sitting next to copy that already says what it is.
    tile: function (icon, color) {
      var el = build({ icon: icon, color: color }, 'span');
      el.className = 'icon-btn icon-btn--tile';
      el.setAttribute('aria-hidden', 'true');
      return el;
    },

    /* Upgrade existing text buttons in place. The plates are inserted
       behind the label rather than replacing it: an icon-only CTA with
       a hover-revealed label is the wrong trade on a page whose whole
       job is the purchase. CSS keeps a solid fallback so a button that
       never gets enhanced still looks finished. */
    enhanceButtons: function (selector, colorFor) {
      Array.prototype.forEach.call(document.querySelectorAll(selector), function (btn) {
        if (btn.classList.contains('is-glass')) return;

        var text = document.createElement('span');
        text.className = 'btn__text';
        while (btn.firstChild) text.appendChild(btn.firstChild);

        var back = document.createElement('span');
        back.className = 'btn__back';
        back.setAttribute('aria-hidden', 'true');
        var color = typeof colorFor === 'function' ? colorFor(btn) : colorFor;
        if (color) back.style.background = backgroundFor(color);

        var front = document.createElement('span');
        front.className = 'btn__front';
        // NOT aria-hidden: the label lives inside this element, so hiding it
        // strips the accessible name off every button and link it is applied to.

        front.appendChild(text);
        btn.appendChild(back);
        btn.appendChild(front);
        btn.classList.add('is-glass');
      });
    }
  };

  global.GlassIcons = GlassIcons;
})(window);
